
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefcf5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefcf5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $800sp = parcelRequire("800sp");

var $4OBpG = parcelRequire("4OBpG");
var $7d106553f897acc8$var$_dec, $7d106553f897acc8$var$_dec2, $7d106553f897acc8$var$_class, $7d106553f897acc8$var$_class2, $7d106553f897acc8$var$_descriptor;
function $7d106553f897acc8$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $7d106553f897acc8$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
function $7d106553f897acc8$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $7d106553f897acc8$export$613c7082da0d7173 = ($7d106553f897acc8$var$_dec = (0, $4OBpG.customElement)("my-counter"), $7d106553f897acc8$var$_dec2 = (0, $4OBpG.property)(), $7d106553f897acc8$var$_dec($7d106553f897acc8$var$_class = ($7d106553f897acc8$var$_class2 = class MyCounter extends (0, $800sp.LitElement) {
    constructor(...args){
        super(...args);
        $7d106553f897acc8$var$_initializerDefineProperty(this, "count", $7d106553f897acc8$var$_descriptor, this);
    }
    render() {
        return (0, $800sp.html)`
            <div>
                <div>The button has been clicked ${this.count} times</div>
                <button @click="${this.increment}">Click me!</button>
            </div>
        `;
    }
    increment() {
        this.count++;
        this.requestUpdate();
        console.log("increment has been clicked " + this.count + " times");
    }
}, $7d106553f897acc8$var$_descriptor = $7d106553f897acc8$var$_applyDecoratedDescriptor($7d106553f897acc8$var$_class2.prototype, "count", [
    $7d106553f897acc8$var$_dec2
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $7d106553f897acc8$var$_class2)) || $7d106553f897acc8$var$_class);


//# sourceMappingURL=index.2ec4ca0e.js.map
